/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prop_EstimateInputs */

const en_prop_estimate = /** @type {(inputs: Prop_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate`)
};

const de_prop_estimate = /** @type {(inputs: Prop_EstimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätzung`)
};

/**
* | output |
* | --- |
* | "Estimate" |
*
* @param {Prop_EstimateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const prop_estimate = /** @type {((inputs?: Prop_EstimateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prop_EstimateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_prop_estimate(inputs)
	return en_prop_estimate(inputs)
});